import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { ReactComponent as SvgDefaultTableError } from '../../img/default_table_error.svg.js';
import { propTypes, defaultProps } from './TableError.types.js';
import styles from './Table.module.scss.js';

var TableError = /** @class */ (function (_super) {
    __extends(TableError, _super);
    function TableError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableError.prototype.render = function () {
        var errorBody = this.props.errorBody;
        return (React__default.createElement("div", { className: styles.ErrorState, "data-testid": this.props['data-testid'] },
            React__default.createElement(SvgDefaultTableError, null),
            React__default.createElement("div", { className: styles.ErrorState_label }, errorBody)));
    };
    TableError.propTypes = propTypes;
    TableError.defaultProps = __assign({}, defaultProps);
    TableError.displayName = 'TableError';
    return TableError;
}(React__default.Component));

export { TableError as default };
